import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editorKey", "handleFirstClick"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fragment, useCallback } from 'react';
import { useShepherdDismissState } from '../../../compose/protected/hooks';
import { usePopOutEditorState } from '../hooks/usePopOutEditorState';
import { trackEvent } from '../../../usage-tracking/clients/usageTracker';
import { togglePopoutComposer } from '../events/popoverComposerEvent';
import { EnlargeIcon, ExitFullScreenIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ATTRIBUTE_STORAGE_PREFIX = `fullscreen-shepherd`;
export const ToolbarExpandButton = _ref => {
  let {
      editorKey,
      handleFirstClick
    } = _ref,
    iconButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isOpen,
    open: openPopout,
    close: closePopout
  } = usePopOutEditorState(editorKey);
  const {
    isDismissed,
    setDismissed
  } = useShepherdDismissState({
    attributeKey: `${ATTRIBUTE_STORAGE_PREFIX}-${editorKey}`
  });
  const openAndDismissShepherdWithTracking = useCallback(() => {
    openPopout();
    if (!isDismissed) setDismissed();
    trackEvent(togglePopoutComposer('open'));
  }, [openPopout, setDismissed, isDismissed]);
  const closePopoutWithTracking = useCallback(() => {
    closePopout();
    trackEvent(togglePopoutComposer('close'));
  }, [closePopout]);
  const handleClick = () => {
    handleFirstClick === null || handleFirstClick === void 0 || handleFirstClick('ToolbarExpandButton');
    if (isOpen) {
      closePopoutWithTracking();
    } else {
      openAndDismissShepherdWithTracking();
    }
  };
  const tooltipMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: isOpen ? 'composer-ui.pop-out.controls.collapse' : 'composer-ui.pop-out.controls.expand'
  });
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(IconButton, Object.assign({
      marginInlineStart: "0",
      "data-test-id": "tabbed-editor-expand-button",
      use: "transparent",
      tooltip: tooltipMessage,
      placement: "top"
    }, iconButtonProps, {
      onClick: handleClick,
      children: isOpen ? /*#__PURE__*/_jsx(ExitFullScreenIcon, {}) : /*#__PURE__*/_jsx(EnlargeIcon, {})
    }))
  }, `expand-button-${isOpen ? 'open' : 'closed'}`);
};
ToolbarExpandButton.displayName = 'ToolbarExpandButton';